import { Component } from 'preact'

import { ContentType } from '@insided/shared/utils/contentType'

/* eslint-disable import/no-internal-modules */
import Content from '@insided/deprecated-preact-components/common/Content'
import PostEditor from '@insided/deprecated-preact-components/editor/postEditorViaAPI'

export interface ReplyContentProps {
  id: string
  topicId: number
  contentType: ContentType
  content: string | null
  showEditor: boolean
  onCancel: () => void
  onSave: (content: string) => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

export interface ReplyContentState {
  content: string | null
  isLoading: boolean
}

class ReplyContent extends Component<ReplyContentProps, ReplyContentState> {
  constructor (props: ReplyContentProps) {
    super(props)
    this.state = {
      ...props,
      isLoading: false
    }
    this.onCancel = this.onCancel.bind(this)
  }

  onCancel () {
    const { content, onCancel } = this.props
    this.setState({ content })
    onCancel()
  }

  onSave (content: string) {
    const { onSave } = this.props
    this.setState({ content })
    onSave(content)
  }

  render () {
    const { showEditor, topicId, contentType, id } = this.props
    const { content } = this.state

    return (
      <div className='post--content post--content-new-editor'>
        {
                showEditor
                  ? (
                    <PostEditor
                      replyId={Number(id)}
                      topicId={topicId}
                      isControl
                      data={content ?? ''}
                      onSuccess={(content) => this.onSave(content)}
                      onCancel={this.onCancel}
                      type={contentType}
                      redirect={false}
                      isGuest={false}
                      disableFileAttachments={false}
                    />
                    )
                  : (
                    <Content
                      content={content ?? ''}
                      className='qa-post-content'
                      isControl
                    />
                    )
            }
      </div>
    )
  }
}

export default ReplyContent
